import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchParts from '../../../../hooks/parts/useFetchParts';
import { setPartsSearchAction } from '../../../../redux/actions/partsActions';
import SearchableSelect from '../SearchableSelect';

const PartSelect = ({ disabled, autoFocus = false }) => {
  const {
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { parts } = useFetchParts({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = parts.map((part) => {
    return {
      label: part.name,
      value: part,
    };
  });

  const handleInputChange = useMemo(
    () =>
      debounce((newValue) => {
        dispatch(setPartsSearchAction(newValue));
      }, 300),
    [dispatch],
  );

  return (
    <div>
      <label className="input-label">Виберіть деталь</label>
      <Controller
        name="part"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled}
            value={value ? { label: value.name, value: value } : null}
            options={selectOptions}
            autoFocus={autoFocus}
            isMobileView={isMobileView}
            placeholder={'Виберіть запчастину'}
            handleInputChange={handleInputChange}
            onChange={(selectedValue) => {
              onChange(selectedValue);
              setValue('partPrice', selectedValue.price);
              clearErrors('partPrice');
            }}
          />
        )}
      />
      {errors['part'] && <span className="text-xs text-contrast1 mt-1">{errors['part'].message}</span>}
    </div>
  );
};
export default PartSelect;
